import React from 'react';
import { Document, Page, StyleSheet, Font } from '@react-pdf/renderer';
import FontFranklinRegular from '../../../../fonts/libre-franklin-v11-latin/libre-franklin-v11-latin-500.ttf';
import FontFranklinBold from '../../../../fonts/libre-franklin-v11-latin/libre-franklin-v11-latin-700.ttf';
import SealImage from '../test-images/SealImage.png';
import PdfSignatureArea from '../pdf-signature/pdf-signature-area';
import PdfSignatureInstructions from '../pdf-signature/pdf-signature-instruction';
import PdfHeader from '../verification-report/pdf-header';
import PdfVerificationSignatureFooter from '../verification/pdf-verification-signature-footer';
import PdfVerificationSignatureInformation from '../verification/pdf-verification-signature-information';

interface PdfTemplateProps {
  data: any;
}

Font.register({
  family: 'Libre Franklin',
  src: FontFranklinRegular,
});

Font.register({
  family: 'Libre Franklin Bold',
  src: FontFranklinBold,
});

export const PdfVerificationSignaturePage: React.FC<PdfTemplateProps> = (props) => {
  const styles = StyleSheet.create({
    page: {
      fontFamily: 'Libre Franklin',
      color: 'black',
      paddingLeft: "12px",
      paddingRight: "12px",
      paddingBottom: "10px",
      paddingTop: "10px"
    }
  });

  return (
    <Document>
      <Page style={styles.page}>
        <PdfHeader />
        <PdfVerificationSignatureInformation data={props.data} />
        <PdfSignatureInstructions  />
        <PdfSignatureArea imageSource={SealImage} />
        <PdfVerificationSignatureFooter data={props.data} />
      </Page>
    </Document>
  );
};
export default PdfVerificationSignaturePage;
